import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import '@/pages/timeline/sections/timeline/timelineSections/certificate/style.css'
export default function PaymentPendingNotice(props: any) {
    const { timeline, common } = useLocalTranslation();
    return (
        <div className='commonMainCon'>
            <p className='commonp1 mb-[8px] text-[#FD3535] font-bold'>{timeline.certificateSection.paymentPendingNotice.h1}</p>
            <p className='commonp1 mb-[15px]'>{timeline.certificateSection.paymentPendingNotice.p1}</p>
            <button 
                disabled
                className='commonb1 commonb1_bg_grey cursor-not-allowed'>
                {common.statusText.claimYourCertificate}
            </button>
        </div>
    );
};

